import React from "react";
import {DeliveryInfoPage} from "./DeliveryInfoPage.jsx";

export const DeliveryInfoWrapper = ({history, match}) => {
    return <DeliveryInfoPage history={history} match={match} />;
};
